/** *************** getters ***********************/
export const GET_INFO = 'GET_INFO'
export const GET_TOKEN = 'GET_TOKEN'
export const GET_USER = 'GET_USER'
export const GET_LOADERS = 'GET_LOADERS'

/** *************** mutations - setters ***********************/
export const SET_INFO = 'SET_INFO'
export const SET_STATE = 'SET_STATE'
export const SET_STATE_PERSIST_LOCAL = 'SET_STATE_PERSIST_LOCAL'
export const SET_TOGGLE_LOADER = 'SET_TOGGLE_LOADER'

/** *************** actions - asynchronous ***********************/
export const RUN_LOGIN = 'RUN_LOGIN' 
export const RUN_USER_LOGIN_2FA = 'RUN_USER_LOGIN_2FA' 
export const RUN_STATE_LOAD = 'RUN_STATE_LOAD'
export const RUN_LOGOUT = 'RUN_LOGOUT'
export const RUN_FORGOT_PASSWORD = 'RUN_FORGOT_PASSWORD'
export const RUN_RESET_PASSWORD_FROM_HASH	= 'RUN_RESET_PASSWORD_FROM_HASH'
export const RUN_CHANGE_PASSWORD	= 'RUN_CHANGE_PASSWORD'
export const RUN_USER_SIGNUP 	 	= 'RUN_USER_SIGNUP'

export const RUN_REGISTER_OPTIONS = 'RUN_REGISTER_OPTIONS' 
export const GET_REGISTER_OPTIONS = 'GET_REGISTER_OPTIONS' 
export const SET_REGISTER_OPTIONS = 'SET_REGISTER_OPTIONS' 
export const RUN_REGISTER_STEP1 = 'RUN_REGISTER_STEP1' 
export const RUN_REGISTER_STEP2 = 'RUN_REGISTER_STEP2'
export const RUN_REGISTER_STEP3 = 'RUN_REGISTER_STEP3' 
export const RUN_GET_USER_REGISTERATION_STEP_DATA = 'RUN_GET_USER_REGISTERATION_STEP_DATA'



// WEBPACK FOOTER //
// ./src/types.js